import { InjectionToken } from '@angular/core';
import { Y42FeatureType } from '@y42/json-schema';

export const FEATURE_TYPE = new InjectionToken<Y42FeatureType>('Y42 Feature Type');
